import { useEffect, useMemo } from "react";
import { toast } from "sonner";
import { useAuth } from "../lib/auth";
import { reportClientEvent } from "../lib/api";

export const Watermark = () => {
  const { user } = useAuth();
  const bg = useMemo(() => {
    const txt = `${user?.email || ""} · ${new Date().toLocaleString("en-IN", { timeZone: "Asia/Kolkata", dateStyle: "medium", timeStyle: "short" })} IST`;
    const svg = `<svg xmlns='http://www.w3.org/2000/svg' width='420' height='220'><text x='10' y='120' transform='rotate(-24 210 110)' fill='rgba(80,90,120,0.05)' font-family='monospace' font-size='13'>${txt}</text></svg>`;
    return `url("data:image/svg+xml;utf8,${encodeURIComponent(svg)}")`;
  }, [user?.email]);
  return <div data-testid="security-watermark" aria-hidden className="pointer-events-none fixed inset-0 z-40 select-none" style={{ backgroundImage: bg }} />;
};

export const useSecurityDeterrents = () => {
  const { can } = useAuth();
  const allowCopy = can("sales", "copy");
  const allowPrint = can("sales", "print");
  useEffect(() => {
    document.body.classList.toggle("ax-no-print", !allowPrint);
    const onKey = (e) => {
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "p" && !allowPrint) {
        e.preventDefault();
        toast.error("Printing is disabled for your role.");
        reportClientEvent("print_blocked");
      }
    };
    const onCopy = (e) => {
      const tag = e.target?.tagName;
      if (allowCopy || tag === "INPUT" || tag === "TEXTAREA") return;
      e.preventDefault();
      toast.error("Copying is disabled for your role. This attempt was logged.");
      reportClientEvent("copy_blocked");
    };
    const onCtx = (e) => {
      if (allowCopy || e.target?.closest?.("input,textarea")) return;
      e.preventDefault();
      reportClientEvent("contextmenu_blocked");
    };
    window.addEventListener("keydown", onKey);
    document.addEventListener("copy", onCopy);
    document.addEventListener("contextmenu", onCtx);
    return () => {
      window.removeEventListener("keydown", onKey);
      document.removeEventListener("copy", onCopy);
      document.removeEventListener("contextmenu", onCtx);
    };
  }, [allowCopy, allowPrint]);
  return { allowCopy, allowPrint };
};
